import type { AppFieldExtendedReactFormApi, DeepKeys, FormOptions } from "@tanstack/react-form";
import { createFormHook } from "@tanstack/react-form";
import { CheckboxField } from "../form-fields/checkbox-field";
import { Condition } from "../form-fields/condition";
import { DatePickerField, DatePickerStandaloneField } from "../form-fields/date-picker-field";
import { FileField } from "../form-fields/file-field";
import { RadioGroupField } from "../form-fields/radio-group-field";
import { SelectField } from "../form-fields/select-field";
import { SubmitButton } from "../form-fields/submit";
import { TextAreaField } from "../form-fields/text-area-field";
import { TextField } from "../form-fields/text-field";
import { fieldContext, formContext } from "./form-context";

type LabelsFor<T> = Record<DeepKeys<T>, string>;

type AnyFormOptions<T> = FormOptions<T, any, any, any, any, any, any, any, any, any, any, any>;

type LabeledFormOptions<T> = AnyFormOptions<T> & {
	labels: LabelsFor<T>;
};

export type NarrowAppField<TData> = AppFieldExtendedReactFormApi<
	TData,
	any,
	any,
	any,
	any,
	any,
	any,
	any,
	any,
	any,
	any,
	any,
	any,
	never
>;

export const { useAppForm, withForm } = createFormHook({
	fieldComponents: {
		TextField,
		SelectField,
		DatePickerField,
		DatePickerStandaloneField,
		CheckboxField,
		FileField,
		RadioGroupField,
		TextAreaField,
		Condition,
	},
	formComponents: {
		SubmitButton,
	},
	fieldContext,
	formContext,
});

const _useLabeledAppForm = <T>(args: LabeledFormOptions<T>) => {
	const { labels, ...formOptions } = args;

	const form = useAppForm(formOptions as AnyFormOptions<T>);

	return {
		form,
		labels,
	};
};
